import ModalPatient from './modalPatient';
import ModalClinician from './modalClinician';
import StartScreenText from './startScreenText';
import { useContext, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useEffect } from 'react';
import { StepsContext } from '../context/StepsContext';
import { useNavigate } from 'react-router-dom';

interface Start {
  id: number;
  url: string;
}

const startScreen = (): JSX.Element => {
  const qContext = useContext(StepsContext);
  const [start, setStart] = useState<Start>();
  const [show, setModalShow] = useState(false);
  const [userPatient, setPatient] = useState(false);
  const handleShow = (patient: boolean): void => {
    setModalShow(true);
    setPatient(patient);
    qContext.userType = patient ? 'patient' : 'clinician';
  };
  const handleHide = (): void => {
    setModalShow(false);
  };
  const navigate = useNavigate();
  const handleStart = (): void => {
    navigate(`/taps2/question/${start?.id}/${start?.url}`);
  };
  qContext.started = true;
  qContext.steps?.setCurrentIndex(0);
  qContext.currentStep = qContext.steps?.stepsArray[qContext.steps.currentIndexValue];
  qContext.answers = {};
  qContext.skippedSteps = [];
  qContext.completedSteps = [];
  qContext.total = qContext.steps?.stepsArray.length!;

  useEffect(() => {
    setStart({
      url: qContext.currentStep?.questionList[0].url!,
      id: qContext.currentStep?.questionList[0].id!,
    });
  }, [qContext]);

  return (
    <div className={show ? 'summary hide' : 'summary'}>
      <div className="introduction">
        <Modal show={show}>
          <Modal.Header>
            <Modal.Title>{userPatient ? 'Patient' : 'Clinician'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{userPatient ? <ModalPatient /> : <ModalClinician />}</Modal.Body>
          <Modal.Footer>
            <Button
              as="button"
              variant="link"
              href={`/taps2/question/${start?.id}/${start?.url}`}
              onClick={handleStart}
            >
              Start
            </Button>
            <Button variant="link" onClick={handleHide}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {show ? null : (
          <div>
            <StartScreenText />

            <div className="role-button-wrapper">
              <Button variant="link" type="button" onClick={() => handleShow(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M6 13h8l-3.5 3.5l1.42 1.42L17.84 12l-5.92-5.92L10.5 7.5L14 11H6v2Z"
                  />
                </svg>
                I am the patient
              </Button>
              <Button variant="link" type="button" onClick={() => handleShow(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M6 13h8l-3.5 3.5l1.42 1.42L17.84 12l-5.92-5.92L10.5 7.5L14 11H6v2Z"
                  />
                </svg>
                I am the clinician
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default startScreen;
